import React from 'react';
import Routes from './Routes';
import './App.css';
import {AppProviders} from "./app-providers";
import ReactGA from 'react-ga';

ReactGA.initialize('UA-216551465-1');

export const App = (props) => {
    return (
        <AppProviders>
            <Routes/>
        </AppProviders>
    );
};

export default App;
